'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_crud$OpenToView(item) {
  this.Kl = null;
  this.Kl = item;
}
export { $c_Lpresto_crud$OpenToView as $c_Lpresto_crud$OpenToView };
$p = $c_Lpresto_crud$OpenToView.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_crud$OpenToView;
/** @constructor */
function $h_Lpresto_crud$OpenToView() {
}
export { $h_Lpresto_crud$OpenToView as $h_Lpresto_crud$OpenToView };
$h_Lpresto_crud$OpenToView.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_crud$OpenToView) && $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_BoxesRunTime$().z(this.Kl, x$0.Kl)));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 1;
});
$p.s = (function() {
  return "OpenToView";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Kl;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_crud$OpenToView(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jc)));
}
export { $isArrayOf_Lpresto_crud$OpenToView as $isArrayOf_Lpresto_crud$OpenToView };
var $d_Lpresto_crud$OpenToView = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_crud$OpenToView, "presto.crud$OpenToView", ({
  jc: 1,
  ca: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_crud$OpenToView as $d_Lpresto_crud$OpenToView };
//# sourceMappingURL=presto.crud$-Open-To-View.js.map
